import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonService } from '../services/common.service';
//import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { constant } from '../constant';
import { Router, NavigationEnd} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Title, Meta } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  mobmenu = false;
  contactNumber: string;
  modalRef: BsModalRef;
  step2 = false
  otp: string;
  fName: string;
  token: string;
  isLoggedIn$ = false;
  isHomepage2 = false;
  attempt = 0;

  constructor(
    private commonService: CommonService,
    //private ngxLoader: NgxUiLoaderService,
    private modalService: BsModalService,
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
    private titleService: Title,
    private metaService: Meta
  ) { }

  ngOnInit() {
    this.attempt = +sessionStorage.getItem('attempts') || 0;
    this.authService.isHomepage2.subscribe(res => {
      this.isHomepage2 = true;
      setTimeout(() => {
        this.fName = localStorage.getItem('fname');
      }, 500);
    })
    this.authService.isLoggedIn.subscribe(status => {
      this.isLoggedIn$ = status;
      this.isHomepage2 = false;
      setTimeout(() => {
        this.fName = localStorage.getItem('fname');
      }, 500);
    })
    $(".closemenu").click(function () {
      $("#navbarNavDropdown").removeClass("show")
    })
    this.token = localStorage.getItem('pmtoken');
    this.fName = localStorage.getItem('fname');
    if (this.token) {
      this.isLoggedIn$ = true;
      this.isHomepage2 = false;
    }
    if (!this.isLoggedIn$ && this.fName) {
      this.isHomepage2 = true;
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.routerState.root),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      map(route => route.snapshot.data)
    )
    .subscribe(data => {
      const defaultTitle = 'ThePolicyMall';
      const defaultDescription = 'ThePolicyMall: Your Trusted Insurance Partner';
      
      this.titleService.setTitle(data.title || defaultTitle);
      this.metaService.updateTag({ name: 'description', content: data.description || defaultDescription });
    });
  }

  getOtp() {
    var regexcontactNo = constant.mobilevalidateregex;
    if (!regexcontactNo.test(this.contactNumber)) {
      this.toastr.error('Please enter a valid 10 digit mobile number', "Error");
      return false;
    } else {
      if (this.attempt <= 3) {
        const url = `/loginSignupRoute/request_login_otp`;
        let body = {
          "contactNumber": this.contactNumber,
          "userType": "customer",
          "policy_purchase":'false'
        }
        this.commonService.post(url, body).subscribe((response) => {
          if (response.error.errorCode === 200) {
            this.step2 = true;
            this.toastr.success("OTP has been sent to your mobile no", "Success")
            // if (response.data.length > 0) {
             
            // } else {
            //   alert('There is some error');
            // }
          }
        }, (error) => {
          //console.log("error ts: ", error);
          this.toastr.error(error.error.error.errorMessage || 'Something went wrong', "Error");
        });
      } else {
        this.toastr.error("You have attempted maximum times!Try after 24 hours", "Error");
        this.modalRef.hide();
      }
    }
  }

  loginpopup(template: TemplateRef<any>) {
    this.step2 = false;
    this.contactNumber = '';
    this.otp = '';
    this.modalRef = this.modalService.show(template, { class: 'common-popup' });
  }

  logout() {
    this.authService.logout()
  }

  doLogin() {
    var regexcontactNo = constant.mobilevalidateregex;
    if (!regexcontactNo.test(this.contactNumber)) {
      this.toastr.error('Please enter a valid 10 digit mobile number', "Error");
      return false;
    } else {
      this.authService
      const url = `/loginSignupRoute/login_with_otp`;
      let body = {
        "contactNumber": this.contactNumber,
        "login_otp": this.otp,
        "userType": "customer"
      }
      if (this.attempt < 4) {
        this.commonService.post(url, body).subscribe((response) => {
          if (response.error.errorCode === 200) {
            if (response.data) {
              let user = response.data;
              const session_id = this.generateSessionId()
              this.authService.login();
              localStorage.setItem('fname', user.first_name);
              localStorage.setItem('fullname', user.userName);
              localStorage.setItem('pmtoken', user.token);
              localStorage.setItem('user_Id', user.userId);
              localStorage.setItem('session_id',session_id)
              this.modalRef.hide();
              this.router.navigate([`userprofile/policy_purchased`]);
            } else {
              alert('There is some error');
            }
          }
        }, (error) => {
          //console.log("error ts: ", error);
          if (error.status == 400) {
            this.attempt++;
            sessionStorage.setItem('attempts', this.attempt.toString());
          }
          let msg = error.error.error.errorMessage || 'Something went wrong';
          this.toastr.error(msg, "Error");
        });
      } else {
        this.toastr.error("You have attempted maximum times!Try after 24 hours", "Error");
        this.modalRef.hide();
      }
    }
  }
  generateSessionId(): string {
    return uuidv4();
  }

}
